import theme, { TMaterialStyles } from '../../theme';

export const materialStyles: TMaterialStyles = {
  container: {
    width: '50px',
    height: '55px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
  },
  attemptsIcon: {
    width: '100%',
    height: '100%',
    position: 'absolute',
  },
  attemptsText: {
    fontSize: '10px',
    fontWeight: '600',
    letterSpacing: '0.1px',
    color: theme.palette.primary.dark,
    position: 'relative',
    top: '2px',
  },
  trainingAttemptsText: {
    fontSize: '9px',
    fontWeight: '600',
    letterSpacing: '0.1px',
    color: theme.palette.primary.dark,
    position: 'relative',
  },
  timerText: {
    fontSize: '10px',
    fontWeight: '600',
    letterSpacing: '0.1px',
    color: theme.palette.primary.dark,
  },
  timerContainer: {
    backgroundColor: 'white',
    position: 'absolute',
    borderRadius: '14px',
    top: '-7px',
    zIndex: 1,
    width: '50px',
    height: '13px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
};
